import { useAppStore } from '../../stores/app';
import type { LeaderboardEntry } from '@beshek/shared';

interface LeaderboardProps {
  entries?: LeaderboardEntry[];
  highlightUserId?: string;
  compact?: boolean;
}

export function Leaderboard({ entries, highlightUserId, compact = false }: LeaderboardProps) {
  const storeLeaderboard = useAppStore((s) => s.leaderboard);
  const userId = useAppStore((s) => s.userId);
  
  const data = entries || storeLeaderboard;
  const highlight = highlightUserId || userId;

  if (data.length === 0) return null;

  const getRankEmoji = (rank: number) => {
    switch (rank) {
      case 1: return '🥇';
      case 2: return '🥈';
      case 3: return '🥉';
      default: return `${rank}.`;
    }
  };

  const displayData = compact ? data.slice(0, 5) : data;

  return (
    <div className="w-full max-w-md mx-auto">
      <h3 className="text-lg font-semibold mb-3 text-center">Таблица лидеров</h3>
      
      <div className="space-y-2">
        {displayData.map((entry) => {
          const isMe = entry.playerId === highlight;
          
          return (
            <div
              key={entry.playerId}
              className={`
                flex items-center justify-between p-3 rounded-xl
                ${isMe ? 'bg-primary-500/20 ring-2 ring-primary-500' : 'bg-white/10'}
              `}
            >
              <div className="flex items-center gap-3">
                <span className="text-xl w-8">{getRankEmoji(entry.rank)}</span>
                <span className={`font-medium ${isMe ? 'text-primary-400' : ''}`}>
                  {entry.avatar || '🎮'} {entry.displayName}
                  {isMe && ' (ты)'}
                </span>
              </div>
              <div className="text-right">
                <div className="font-bold text-lg">{entry.score}</div>
                {entry.correctAnswers !== undefined && (
                  <div className="text-xs text-gray-400">
                    {entry.correctAnswers} верных
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {compact && data.length > 5 && (
        <div className="text-center text-sm text-gray-400 mt-2">
          +{data.length - 5} игроков
        </div>
      )}
    </div>
  );
}
